import * as React from 'react';

function SvgCameraStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.55 10.6h3.972a.7.7 0 01.7.7v10.095a.7.7 0 01-.7.7H6.624a.7.7 0 01-.7-.7V11.3a.7.7 0 01.7-.7h3.971l.41-2.446a.7.7 0 01.69-.585h7.756a.7.7 0 01.69.585l.41 2.446zm3.272 1.4h-3.864a.7.7 0 01-.69-.584l-.41-2.447h-6.57l-.41 2.447a.7.7 0 01-.69.584H7.324v8.695h16.498V12zm-8.249 7.29c-2.032 0-3.683-1.633-3.683-3.652 0-2.02 1.65-3.654 3.683-3.654s3.683 1.634 3.683 3.654c0 2.019-1.65 3.653-3.683 3.653zm0-1.4c1.263 0 2.283-1.01 2.283-2.252 0-1.243-1.02-2.254-2.283-2.254-1.262 0-2.283 1.01-2.283 2.254 0 1.243 1.02 2.253 2.283 2.253z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgCameraStroke;
